<div class="vs-card" *ngIf="quoteDetails$ | async as quoteDetails else loading">   
    <div class="row">
        <div class="col-1">
            <div class="vs-card-logo">
                <i class="material-icons vs-card-logo-font">playlist_add_check</i>
            </div>
        </div>
        <div class="col-11">
            <div class="bold quote-title">{{ "quoteTracking.actionPending" | cxTranslate }}</div>
            <div class="quote-title">
                {{ "quoteTracking.takeAction" | cxTranslate }}
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-1">
    
        </div>
        <div class="col-11 space-top-bottom">
            <div class="vs-radio-button">
                <input id="accept-reject" type="radio" value="accept" name="terms-radio-group" (click)="selectOperation($event)"
                *ngIf="(checkUserEnabled(accessibility.SELLABILITYFLAG) | async) ||
                (checkUserEnabled(accessibility.QUOTABILITYFLAG) | async)">
                <label for="accept-reject" 
                *ngIf="(checkUserEnabled(accessibility.SELLABILITYFLAG) | async) ||
                (checkUserEnabled(accessibility.QUOTABILITYFLAG) | async)">
                {{ "quoteTracking.acceptReject" | cxTranslate }}
                </label>
              
                <!-- Commenting code as per ticket RITM00716694 & US610308
                <input id="accept-additional" type="radio" value="additional" name="terms-radio-group" (click)="selectOperation($event)"
                *ngIf="(checkUserEnabled(accessibility.SELLABILITYFLAG) | async) ||
                (checkUserEnabled(accessibility.QUOTABILITYFLAG) | async)">
                <label for="accept-additional" 
                *ngIf="(checkUserEnabled(accessibility.SELLABILITYFLAG) | async) ||
                (checkUserEnabled(accessibility.QUOTABILITYFLAG) | async)">
                {{ "quoteTracking.acceptAdditional" | cxTranslate }}
                </label>-->

                <input id="merge-quote" type="radio" value="merge" name="terms-radio-group" (click)="selectOperation($event)"
                *ngIf="(checkUserEnabled(accessibility.SELLABILITYFLAG) | async)">
                <label for="merge-quote" *ngIf="(checkUserEnabled(accessibility.SELLABILITYFLAG) | async)">
                    {{ "quoteTracking.mergeQuote" | cxTranslate }}
                </label>
                <input id="revision" type="radio" value="revision" name="terms-radio-group" (click)="selectOperation($event)" 
                *ngIf="(checkUserEnabled(accessibility.QUOTABILITYFLAG) | async) && !quoteDetails?.quoteIsPartial">
                <label for="revision" *ngIf="(checkUserEnabled(accessibility.QUOTABILITYFLAG) | async) && !quoteDetails?.quoteIsPartial">
                    {{ "quoteTracking.reqRevision" | cxTranslate }}
                </label>
            </div>
        </div>
        
    </div>
    <div *ngIf="status === 'accept'" class='row'>
        <div class=col-md-1>

        </div>
        <div class="col-md-11">
            <div class="info-text">
                {{ "quoteTracking.acceptReject2" | cxTranslate }}
            </div>
            <div>
                <button class="vs-primary-btn" (click)='quoteAcceptance()' autofocus>
                    <i class="material-icons">thumbs_up_down</i>{{ "quoteTracking.proceed" | cxTranslate }}
                </button>
            </div>
        </div>
    </div>
    <div *ngIf="status === 'additional'" class='row'>
        <div class=col-md-1>

        </div>
        <div class="col-md-11">
            <div class="info-text">
                {{ "quoteTracking.acceptAdditional2" | cxTranslate }}
            </div>
            <div>
                <button class="vs-primary-btn" (click)='quoteAcceptance()' autofocus>
                    <i class="material-icons">thumb_up</i>{{ "quoteTracking.proceed" | cxTranslate }}
                </button>
            </div>
        </div>
    </div>
    <div *ngIf="status === 'merge'" class="row">
        <div class=col-md-1>

        </div>
        <div class="col-md-11">
            <div class="info-text">
                {{ "quoteTracking.mergeQuote2" | cxTranslate }}  
            </div>
            <div>
                <button class="vs-primary-btn" [disabled]="added" (click)='quoteMerge()' autofocus>
                    <i class="material-icons" >call_merge</i> {{mergeText}}
                </button>
            </div>
        </div>
    </div>
    <div *ngIf="status === 'revision'" class="row">
        <div class="col-md-1">

        </div>
        <div class="col-md-11">
            <div class="info-text ">
                {{ "quoteTracking.reqRevision2" | cxTranslate }}
            </div>
            <div>
                <label class="info-text">Comment <span class="required">*</span></label>
                <textarea class='comment' [(ngModel)]="comment"  maxlength="255"></textarea>
                <label class="required" *ngIf="comment.trim().length === 0 && submitted">{{ "quoteTracking.comment" | cxTranslate }}</label>
            </div>
            <div>
                <button class="vs-primary-btn" [disabled]='comment.trim().length === 0' (click)="openModal()" autofocus>
                    <i class="material-icons">receipt</i>
                    {{ "quoteTracking.proceed" | cxTranslate }}
                </button>
            </div>
        </div>
        
    </div>
</div>
<ng-template #loading>
  <div class="cx-spinner">
    <cx-spinner></cx-spinner>
  </div>
</ng-template>
